function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.999 20.12c.3.27.555.602.73.998a2.922 2.922 0 0 1-1.503 3.852 2.921 2.921 0 0 1-3.851-1.503 2.894 2.894 0 0 1-.24-1.214l4.864-2.132zM7.209 1.75c.06.14.094.284.13.429 3.074-.063 6.108 1.809 7.693 4.992 0 0 2.349 5.391 4.928 5.82.079.005 1.463.04 1.885 1.047.397.954-.422 2.23-1.847 2.844l-15.43 6.65c-1.424.614-2.997.368-3.333-.608-.333-.962.397-1.857.466-1.937C3.157 18.75.71 13.39.71 13.39-.662 9.938.037 6.647 2.088 4.494c-.084-.13-.17-.25-.234-.399A2.92 2.92 0 0 1 3.356.247 2.925 2.925 0 0 1 7.208 1.75z"
});

var SvgNotBell = function SvgNotBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not-bell.5d82ff96.svg";
export { ForwardRef as ReactComponent };